import { type CalculateFrequencyParams, calculateFrequency } from '@libs/api-proxy-client';
import type { CalculateFrequencyResponse } from '@libs/common-types';

export type { CalculateFrequencyParams, CalculateFrequencyResponse };

export async function fetchCalculateFrequency(params: CalculateFrequencyParams): Promise<CalculateFrequencyResponse> {
    return calculateFrequency(params);
}
